import useTransformTimeslots from './useTransformTimeslots'

export default useTransformTimeslots
